module.exports = __webpack_public_path__ + "media/images/salespartner/bg-mv-left-f9d2b4d8f0c3a85c5f5f7f0f19c14457.svg";